import ActivationContainer from "./ActivationContainer";

function Activation() {
  return <ActivationContainer />;
}

export default Activation;
